import { Button, Stack, Typography } from '@mui/material'
import React from 'react'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Link } from 'react-router';

function Home() {

    return (
        <>
            <Stack sx={{ backgroundColor: "#eee", textAlign: "center", minHeight: "90vh", borderRadius: "6px" }} alignItems={"center"} justifyContent={"center"}>
                <Typography variant='h5' sx={{ fontWeight: "bold" }} >
                    .  مرحبا بك محمد في منصة نبني
                </Typography>
                <Typography variant='body1' >
                    لا يوجد أي حالة تحتاج للدعم ,يمكنك تقديم طلب للدعم الآن
                </Typography>

                <Link to={"/InputInfoPersonal"} className='btnLink' >
                    <ArrowBackIcon sx={{ mt: 1 }} />تقديم طلب الدعم
                </Link>
            </Stack>
        </>
    )
}

export default Home